import { useState, useEffect } from "react";
import { ReactTransliterate } from "react-transliterate";
import editIcon from "../../assests/icons/edit.jpg";
import deleteIcon from "../../assests/icons/delete.jpg";
import publishIcon from "../../assests/icons/publish.png";
import { isAdmin, isApprover, isPublisher } from "../utils/auth.js";
import parse from "html-react-parser";
import { showHideLoader, processImage } from "../utils/helper.js";
import {
  getVidyamanMandalTypes,
  getYears,
} from "../../network/lib/masterData.js";
import {
  vidyamanMandalObject,
  save,
  update,
  deleteLive,
  deletePreview,
  publish,
  getPreviewByVidyamanMandalType,
  getLiveByVidyamanMandalType,
} from "../../network/lib/vidyamanMandal.js";
import { convertToNumerals } from "../utils/helper.js";

function VidyamanMandal({ user }) {
  const [vidyamanMandalTypes, setVidyamanMandalTypes] = useState();
  const [years, setYears] = useState();
  const [vidyamanMandalType, setVidyamanMandalType] = useState("1");
  const [previewVidyamanMandalType, setPreviewVidyamanMandalType] =
    useState("1");
  const [liveVidyamanMandalType, setLiveVidyamanMandalType] = useState("1");
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [telephone, setTelephone] = useState("");
  const [designation, setDesignation] = useState("");
  const [address, setAddress] = useState("");
  const [fromPeriod, setFromPeriod] = useState("1");
  const [toPeriod, setToPeriod] = useState("1");
  const [image, setImage] = useState("");
  const [previewData, setPreviewData] = useState();
  const [liveData, setLiveData] = useState();

  const [id, setId] = useState(0);

  const admin = isAdmin(user.roleId);
  const approver = isApprover(user.roleId);
  const publisher = isPublisher(user.roleId);

  useEffect(() => {
    !vidyamanMandalTypes && populateVidyamanMandalTypes();
    !years && populateYears();
  }, []);

  const populateVidyamanMandalTypes = () => {
    getVidyamanMandalTypes().then((res) => {
      if (res.status == 200) {
        setVidyamanMandalTypes(res.data);
        setPreviewVidyamanMandalType(res.data);
        setLiveVidyamanMandalType(res.data);
      }
    });
  };

  const populateYears = () => {
    getYears().then((res) => {
      if (res.status == 200) {
        setYears(res.data);
      }
    });
  };

  const setToDefault = () => {
    setVidyamanMandalType("1");
    setName("");
    setMobile("");
    setTelephone("");
    setDesignation("");
    setAddress("");
    setFromPeriod("1");
    setToPeriod("1");
    setImage("");
    setId(0);
    setPreviewData(undefined);
    setLiveData(undefined);
  };

  const handleCancel = (e) => {
    e.preventDefault();
    resetMessage();
    setToDefault();
  };

  const resetMessage = () => {
    let message = document.getElementById("message");
    message.innerHTML = "";
    message.classList.replace("success", "alert");
    return message;
  };

  const handleEdit = (e) => {
    e.preventDefault();
    resetMessage();

    let dataParams = e.target.getAttribute("data-params");
    if (dataParams) {
      let params = JSON.parse(dataParams);
      setId(params.id);
      setVidyamanMandalType(params.vidyamanMandalTypeId);
      setName(params.name);
      setMobile(params.mobile);
      setTelephone(params.telephone);
      setDesignation(params.designation);
      setAddress(params.address);
      setFromPeriod(params.fromPeriodId);
      setToPeriod(params.toPeriodId);
      setImage(params.image);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let message = resetMessage();

    setLiveData(undefined);
    setPreviewData(undefined);

    let fromPeriodText = years.find((x) => x.id == parseInt(fromPeriod)).name;
    let toPeriodText = years.find((x) => x.id == parseInt(toPeriod)).name;

    if (name == "") {
      message.innerHTML = "Please provide Name";
    } else if (
      convertToNumerals(fromPeriodText) > convertToNumerals(toPeriodText)
    ) {
      message.innerHTML =
        "Please select valid 'To Period'. 'From Period' cannot be greater than 'To Period'";
    } else {
      showHideLoader(true);

      vidyamanMandalObject.id = id;
      vidyamanMandalObject.vidyamanMandalTypeId = vidyamanMandalType;
      vidyamanMandalObject.name = name;
      vidyamanMandalObject.mobile = mobile;
      vidyamanMandalObject.telephone = telephone;
      vidyamanMandalObject.designation = designation;
      vidyamanMandalObject.address = address;
      vidyamanMandalObject.fromPeriodId = fromPeriod;
      vidyamanMandalObject.toPeriodId = toPeriod;
      vidyamanMandalObject.image = image;
      vidyamanMandalObject.userName = user.userName;

      if (id == 0) {
        save(vidyamanMandalObject).then((res) => {
          if (res.status == 200 && res.data) {
            message.classList.replace("alert", "success");
            message.innerHTML = "Data saved successfully!!!";
            setToDefault();
          } else {
            message.innerHTML = "Some error occurred. Please try again";
          }
          showHideLoader();
        });
      } else {
        update(vidyamanMandalObject).then((res) => {
          if (res.status == 200 && res.data) {
            message.classList.replace("alert", "success");
            message.innerHTML = "Data updated successfully!!!";
            setToDefault();
          } else {
            message.innerHTML = "Some error occurred. Please try again";
          }
          showHideLoader();
        });
      }
    }
  };

  const fetchPreviewData = (vidyamanMandalType) => {
    showHideLoader(true);

    getPreviewByVidyamanMandalType(vidyamanMandalType)
      .then((resp) => {
        if (resp.status == 200) {
          setPreviewData(resp.data);
          setLiveData(undefined);
          showHideLoader();
        }
      })
      .catch((e) => console.log(e));
  };

  const handlePreviewData = (e) => {
    e.preventDefault();
    resetMessage();
    setPreviewVidyamanMandalType("1");
    fetchPreviewData("1");
  };

  const fetchLiveData = (vidyamanMandalType) => {
    showHideLoader(true);

    getLiveByVidyamanMandalType(vidyamanMandalType)
      .then((resp) => {
        if (resp.status == 200) {
          setLiveData(resp.data);
          setPreviewData(undefined);
          showHideLoader();
        }
      })
      .catch((e) => console.log(e));
  };

  const handleLiveData = (e) => {
    e.preventDefault();
    resetMessage();
    setLiveVidyamanMandalType("1");
    fetchLiveData("1");
  };

  const handleDeletePreview = (e) => {
    e.preventDefault();
    let message = resetMessage();
    if (window.confirm("Do you really want to delete the item from Preview?")) {
      let params = e.target.getAttribute("data-params");
      if (params) {
        vidyamanMandalObject.id = parseInt(params);
        vidyamanMandalObject.userName = user.userName;

        deletePreview(vidyamanMandalObject).then((res) => {
          if (res.status == 200 && res.data) {
            fetchPreviewData(previewVidyamanMandalType);
          } else {
            message.innerHTML = "Some error occurred. Please try again";
          }
        });
      }
    }
  };

  const handleDeleteLive = (e) => {
    e.preventDefault();
    let message = resetMessage();
    if (
      window.confirm(
        "Do you really want to delete the item from Live? This will be moved to Preview."
      )
    ) {
      let params = e.target.getAttribute("data-params");
      if (params) {
        vidyamanMandalObject.id = parseInt(params);
        vidyamanMandalObject.userName = user.userName;

        deleteLive(vidyamanMandalObject).then((res) => {
          if (res.status == 200 && res.data) {
            fetchLiveData(liveVidyamanMandalType);
          } else {
            message.innerHTML = "Some error occurred. Please try again";
          }
        });
      }
    }
  };

  const handlePublish = (e) => {
    e.preventDefault();
    let message = resetMessage();

    let params = e.target.getAttribute("data-params");
    if (params) {
      vidyamanMandalObject.id = parseInt(params);
      vidyamanMandalObject.userName = user.userName;

      publish(vidyamanMandalObject).then((res) => {
        if (res.status == 200 && res.data) {
          fetchPreviewData(previewVidyamanMandalType);
          setToDefault();
        } else {
          message.innerHTML = "Some error occurred. Please try again";
        }
      });
    }
  };

  const handleImage = (e) => {
    processImage(e.target.files[0], resetMessage(), setImage);
  };

  const contents = (
    <>
      <table>
        <tbody>
          <tr>
            <th align="center" colSpan="4">
              Vidyaman Mandal
            </th>
          </tr>
          <tr>
            <td align="right">
              <span>Vidyaman Mandal Type</span>
            </td>
            <td colSpan={3}>
              {vidyamanMandalTypes && (
                <select
                  onChange={(e) => setVidyamanMandalType(e.target.value)}
                  value={vidyamanMandalType}
                  style={{ width: "274px" }}
                >
                  {vidyamanMandalTypes.map((x, i) => (
                    <option key={i} value={x.id}>
                      {x.name}
                    </option>
                  ))}
                </select>
              )}
            </td>
          </tr>
          <tr>
            <td align="right">
              <span className="required">Name</span>
            </td>
            <td colSpan={3}>
              <ReactTransliterate
                renderComponent={(props) => (
                  <textarea {...props} rows="1" cols="95" />
                )}
                value={name}
                onChangeText={(text) => {
                  setName(text);
                }}
                lang="mr"
              />
            </td>
          </tr>
          <tr>
            <td align="right">
              <span>Mobile Number</span>
            </td>
            <td colSpan={3}>
              <input
                type="number"
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
                style={{ width: "255px" }}
              />
            </td>
          </tr>
          {/* <tr>
            <td align="right">
              <span>Telephone Number</span>
            </td>
            <td colSpan={3}>
              <input
                type="number"
                value={telephone}
                onChange={(e) => setTelephone(e.target.value)}
                style={{ width: "255px" }}
              />
            </td>
          </tr>*/}
          <tr>
            <td align="right">
              <span>Designation</span>
            </td>
            <td colSpan={3}>
              <ReactTransliterate
                renderComponent={(props) => (
                  <textarea {...props} rows="1" cols="95" />
                )}
                value={designation}
                onChangeText={(text) => {
                  setDesignation(text);
                }}
                lang="mr"
              />
            </td>
          </tr>
          <tr>
            <td align="right">
              <span>From Period</span>
            </td>
            <td>
              {years && (
                <select
                  onChange={(e) => setFromPeriod(e.target.value)}
                  value={fromPeriod}
                  style={{ width: "274px" }}
                >
                  {years.map((x, i) => (
                    <option key={i} value={x.id}>
                      {x.name}
                    </option>
                  ))}
                </select>
              )}
            </td>
            <td align="right">
              <span>To Period</span>
            </td>
            <td>
              {years && (
                <select
                  onChange={(e) => setToPeriod(e.target.value)}
                  value={toPeriod}
                  style={{ width: "274px" }}
                >
                  {years.map((x, i) => (
                    <option key={i} value={x.id}>
                      {x.name}
                    </option>
                  ))}
                </select>
              )}
            </td>
          </tr>
          {/* <tr>
            <td align="right">
              <span>Address</span>
            </td>
            <td colSpan={3}>
              <ReactTransliterate
                renderComponent={(props) => (
                  <textarea {...props} rows="4" cols="95" />
                )}
                value={address}
                onChangeText={(text) => {
                  setAddress(text);
                }}
                lang="mr"
              />
            </td>
          </tr> */}
          <tr>
            <td align="right">
              <span>Photo</span>
            </td>
            <td>
              <label
                htmlFor="file-upload"
                className="custom-file-upload"
                style={{ width: "259px", textAlign: "center" }}
              >
                Browse
              </label>
              <input
                type="file"
                id="file-upload"
                accept="image/*"
                onChange={(e) => handleImage(e)}
              />
            </td>
            <td colSpan={2}>
              {image && (
                <img
                  src={image}
                  style={{ width: "150px", height: "150px", float: "left" }}
                />
              )}
            </td>
          </tr>
          <tr>
            <td colSpan={2}></td>
            <td
              colSpan={2}
              style={{ textAlign: "right", paddingRight: "62px" }}
            >
              <input
                className="btn"
                type="submit"
                value="Cancel"
                id="btnCancel"
                onClick={handleCancel}
              />
              &nbsp;&nbsp;
              <input
                className="btn"
                type="submit"
                value="Submit"
                id="btnSubmit"
                onClick={handleSubmit}
              />
            </td>
          </tr>
          <tr>
            <td colSpan="4" style={{ textAlign: "center" }}>
              <div
                id="message"
                className="alert"
                style={{ textAlign: "center" }}
              ></div>
            </td>
          </tr>
          <tr>
            <td></td>
            <td colSpan={2}>
              <input
                className="btn"
                type="submit"
                style={{ float: "left" }}
                value="View Preview"
                id="btnPreviewData"
                onClick={handlePreviewData}
              />
              &nbsp;&nbsp;
              <input
                className="btn"
                type="submit"
                value="View Live"
                id="btnLiveData"
                onClick={handleLiveData}
              />
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
      {previewData && (
        <table className="alternate-row">
          <thead>
            <tr>
              <th align="center" colSpan={admin ? 9 : approver ? 8 : 7}>
                Preview
              </th>
            </tr>
            <tr align="center">
              <td colSpan={admin ? 9 : approver ? 8 : 7}>
                <span>Vidyaman Mandal Type: </span>
                {vidyamanMandalTypes && (
                  <select
                    onChange={(e) => {
                      setPreviewVidyamanMandalType(e.target.value);
                      fetchPreviewData(e.target.value);
                    }}
                    value={previewVidyamanMandalType}
                    style={{ width: "274px" }}
                  >
                    {vidyamanMandalTypes.map((x, i) => (
                      <option key={i} value={x.id}>
                        {x.name}
                      </option>
                    ))}
                  </select>
                )}
              </td>
            </tr>
          </thead>
          <tbody>
            <tr align="center">
              {publisher && (
                <td style={{ textAlign: "center" }}>
                  <u>Publish</u>
                </td>
              )}
              <td>
                <u>Name</u>
              </td>
              {/* <td>
                <u>Vidyaman Mandal Type</u>
              </td> */}
              <td>
                <u>Mobile</u>
              </td>
              {/* <td>
                <u>Telephone</u>
              </td> */}
              <td>
                <u>Designation</u>
              </td>
              <td style={{ textAlign: "center" }}>
                <u>From Period</u>
              </td>
              <td style={{ textAlign: "center" }}>
                <u>To Period</u>
              </td>
              {/* <td>
                <u>Address</u>
              </td> */}
              <td style={{ textAlign: "center" }}>
                <u>Image</u>
              </td>
              <td style={{ textAlign: "center" }}>
                <u>Edit</u>
              </td>
              {admin && (
                <td style={{ textAlign: "center" }}>
                  <u>Delete</u>
                </td>
              )}
            </tr>
            {previewData.length > 0 ? (
              previewData.map((x, i) => (
                <tr key={i + 1} align="center">
                  {publisher && (
                    <td style={{ textAlign: "center" }}>
                      <img
                        className="handle"
                        data-params={x.id}
                        onClick={handlePublish}
                        src={publishIcon}
                        alt="Publish"
                        border="0px"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </td>
                  )}
                  <td>{x.name}</td>
                  {/* <td>{x.vidyamanMandalType}</td> */}
                  <td>{x.mobile}</td>
                  {/* <td>{x.telephone}</td> */}
                  <td>{x.designation}</td>
                  <td style={{ textAlign: "center" }}>{x.fromPeriod}</td>
                  <td style={{ textAlign: "center" }}>{x.toPeriod}</td>
                  {/* <td>{x.address}</td> */}
                  <td style={{ textAlign: "center" }}>
                    {x.image &&
                      parse(`<img src=${x.image}  style="width: 60px"/>`)}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    <img
                      className="handle"
                      data-params={JSON.stringify(x)}
                      onClick={handleEdit}
                      src={editIcon}
                      alt="Edit"
                      border="0px"
                      style={{ width: "20px", height: "20px" }}
                    />
                  </td>
                  {admin && (
                    <td style={{ textAlign: "center" }}>
                      <img
                        className="handle"
                        data-params={x.id}
                        onClick={handleDeletePreview}
                        src={deleteIcon}
                        alt="Delete"
                        border="0px"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={admin ? 9 : approver ? 8 : 7}
                  style={{ textAlign: "center" }}
                >
                  No Data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
      {liveData && (
        <table className="alternate-row">
          <thead>
            <tr>
              <th align="center" colSpan={admin ? 7 : 6}>
                Live
              </th>
            </tr>
            <tr align="center">
              <td colSpan={admin ? 7 : 6}>
                <span>Vidyaman Mandal Type: </span>
                {vidyamanMandalTypes && (
                  <select
                    onChange={(e) => {
                      setLiveVidyamanMandalType(e.target.value);
                      fetchLiveData(e.target.value);
                    }}
                    value={liveVidyamanMandalType}
                    style={{ width: "274px" }}
                  >
                    {vidyamanMandalTypes.map((x, i) => (
                      <option key={i} value={x.id}>
                        {x.name}
                      </option>
                    ))}
                  </select>
                )}
              </td>
            </tr>
          </thead>
          <tbody>
            <tr align="center">
              <td>
                <u>Name</u>
              </td>
              {/* <td>
                <u>Vidyaman Mandal Type</u>
              </td> */}
              <td>
                <u>Mobile</u>
              </td>
              {/* <td>
                <u>Telephone</u>
              </td> */}
              <td>
                <u>Designation</u>
              </td>
              <td style={{ textAlign: "center" }}>
                <u>From Period</u>
              </td>
              <td style={{ textAlign: "center" }}>
                <u>To Period</u>
              </td>
              {/* <td>
                <u>Address</u>
              </td> */}
              <td style={{ textAlign: "center" }}>
                <u>Image</u>
              </td>
              {admin && (
                <td style={{ textAlign: "center" }}>
                  <u>Delete</u>
                </td>
              )}
            </tr>
            {liveData.length > 0 ? (
              liveData.map((x, i) => (
                <tr key={i + 1} align="center">
                  <td>{x.name}</td>
                  {/* <td>{x.vidyamanMandalType}</td> */}
                  <td>{x.mobile}</td>
                  {/* <td>{x.telephone}</td> */}
                  <td>{x.designation}</td>
                  <td style={{ textAlign: "center" }}>{x.fromPeriod}</td>
                  <td style={{ textAlign: "center" }}>{x.toPeriod}</td>
                  {/* <td>{x.address}</td> */}
                  <td style={{ textAlign: "center" }}>
                    {x.image &&
                      parse(`<img src=${x.image}  style="width: 60px"/>`)}
                  </td>
                  {admin && (
                    <td style={{ textAlign: "center" }}>
                      <img
                        className="handle"
                        data-params={x.id}
                        onClick={handleDeleteLive}
                        src={deleteIcon}
                        alt="Delete"
                        border="0px"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={admin ? 7 : 6} style={{ textAlign: "center" }}>
                  No Data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </>
  );

  return contents;
}

export default VidyamanMandal;
